import ControllerBase from './../../../../global/js/ControllerBase';


export default class ControllerTableContents extends ControllerBase {
	constructor(element: HTMLElement) {
		super(element);

		this.toggleNavigationElement();
	}

	private toggleNavigationElement(): void {
        const tableElement = <HTMLDivElement> document.getElementsByClassName("m-table-contents")[0];

        window.onscroll = function(){
            if(tableElement.getBoundingClientRect().bottom <= 0){
                if((<HTMLDivElement> document.getElementsByClassName("m-table-contents__navigation")[0])?.classList.contains("non-visible")){
                    (<HTMLDivElement> document.getElementsByClassName("m-table-contents__navigation")[0])?.classList.remove("non-visible");
                }
            }

            if(tableElement.getBoundingClientRect().bottom >= 0 || ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) ){
                if(!(<HTMLDivElement> document.getElementsByClassName("m-table-contents__navigation")[0])?.classList.contains("non-visible")){
                    (<HTMLDivElement> document.getElementsByClassName("m-table-contents__navigation")[0])?.classList.add("non-visible");
                }
            }

        }
	}
}
